import React from "react";
import {Button, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";

class FromToForm extends React.Component {
    render () {
        return (
            <Form inline className="right" onSubmit={this.props.handleSubmit}>
                <FormGroup controlId="formDateFrom">
                    <ControlLabel>{this.props.from}</ControlLabel>
                    {' '}
                    <FormControl type="number" placeholder="Od" onChange={this.props.handleChangeFrom}/>
                </FormGroup>
                {' '}
                <FormGroup controlId="formDateTo">
                    <ControlLabel>{this.props.to}</ControlLabel>
                    {' '}
                    <FormControl type="number" placeholder="Do" onChange={this.props.handleChangeTo}/>
                </FormGroup>
                {' '}
                <Button type="submit" className="btn-primary">
                    Vybrat
                </Button>
            </Form>
        );
    }
}

export default FromToForm;



/** WEBPACK FOOTER **
 ** ./src/components/Forms/FromToForm.js
 **/